import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";
import { Subject } from "rxjs";

import { PostMessageService } from "@core/post-message.service";

@Component({
  selector: "app-snow",
  template: ""
})
export class SnowComponent implements OnInit, OnDestroy {
  public n = 60;
  public flakes: Flake[] = [];
  public interval: number | null = null;
  @Output() public snowChanges: EventEmitter<boolean> = new EventEmitter<boolean>();

	private unsubscribe$$: Subject<void> = new Subject<void>();

  constructor(
    private elementRef: ElementRef,
		private postMessageService: PostMessageService,
  ) {}

  public ngOnInit(): void {
    this.postMessageService.snow$$.pipe().subscribe(snow => {
      if (!snow) {
        this.stop();
      }
    });
    this.build();
    this.run();
  }

	public ngOnDestroy(): void {
		this.unsubscribe$$.next();
		this.unsubscribe$$.complete();
	}

  private getScreenSize(): { w: number; h: number } {
    return {
      w:
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth,
      h:
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight,
    };
  }

  private build(): void {
    const { w, h } = this.getScreenSize();

    for (let i = 0; i < this.n; i++) {
      const flake = new Flake();

      flake.setPosition(
        Math.round(Math.random() * w - 20),
        Math.round(Math.random() * h - 100)
      );

      this.flakes.push(flake);
      this.elementRef.nativeElement.appendChild(flake.nativeElement);
    }
  }

  private run(): void {
    if (this.interval == null) {
      this.interval = window.setInterval(() => {
        const scrollTop = document.querySelector("html")?.scrollTop;
        const { w, h } = this.getScreenSize();

        this.flakes.forEach((flake) => {
          const p = flake.nativeElement.getBoundingClientRect();
          let y = p.top + (1 + Math.random()) * flake.my;

          if (y < 0) {
            y = h;
          }

          if (y > h) {
            y = 0;
          }

          const vx = (-3 * flake.mx * (-w * 0.5)) / w;
          let x = p.left + Math.random() - 0.5 + vx;

          if (x < 0) {
            x = w - 20;
          }

          if (x > w - 20) {
            x = 0;
          }

          if (Math.abs(flake.mx) < 4) {
            if (Math.random() < 1e-3) {
              flake.mx *= -1;
            }
          } else {
            if (Math.random() < 5e-2) {
              flake.mx *= -1;
            }
            if (Math.random() < 5e-2) {
              flake.my *= -1;
            }
          }

          flake.setPosition(x, y + scrollTop!);
        });

        const kills = this.flakes.filter((flake) => flake.my === 0).length;

        if (kills === this.n) {
          this.build();
          this.n *= 2;
        }
      }, 50);
    }
  }

  private stop(): void {
    if (this.interval != null) {
      window.clearInterval(this.interval);
      this.snowChanges.emit(false);
    }
  }
}

class Flake {
  public nativeElement: HTMLDivElement;
  public mx = 1;
  public my = 1;

  constructor() {
    this.nativeElement = document.createElement("div");
    this.nativeElement.style.position = "fixed";
    this.nativeElement.style.zIndex = "5000";
    this.nativeElement.style.userSelect = "none";
    this.nativeElement.style.padding = "0em";
    this.nativeElement.style.pointerEvents = "none";
    this.nativeElement.style.fontSize = `${Math.round(
      10 + 20 * Math.random()
    )}px`;
    this.flake();
  }

  public setPosition(x: any, y: any): void {
    this.nativeElement.style.left = `${x}px`;
    this.nativeElement.style.top = `${y}px`;
  }

  public flake(): void {
    this.mx = Math.sign(this.mx);
    this.my = 1;
    this.nativeElement.innerHTML = "&#10052;";
    this.nativeElement.style.color = "#9999AA";
  }
}
